import React, { useEffect, useState } from "react";
import "./Notification_Settings.css";
import Pink_Btn from "../../../../common/common_btn/pink_btn/Pink_Btn";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationSetting,
  updateNotificationSetting,
} from "../../../../../features/notifications/notificationSlice";
import Success_Modal from "../../../../common/common_modal/success_modal/Success_Modal";

const Notification_Settings = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const notifications = useSelector((state) => state.notification.setting);

  const [settings, setSettings] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const options = [
    { label: "New Videos", key: "new_video" },
    { label: "New Articles", key: "new_article" },
    { label: "New Audios", key: "new_audio" },
    { label: "Gurudev Quotes", key: "gurudev_quote" },
    { label: "Announcements", key: "announcement" },
  ];

  useEffect(() => {
    dispatch(getNotificationSetting());
  }, [dispatch]);

  useEffect(() => {
    if (notifications) {
      setSettings(notifications);
    }
  }, [notifications]);

  // if (!settings) return null;



  const handleMainToggle = () => {
    const newStatus = !settings?.all_status;

    setSettings((prev) => ({
      ...prev,
      all_status: newStatus,

      ...(newStatus === false && {
        new_video: false,
        new_article: false,
        new_audio: false,
        gurudev_quote: false,
        announcement: false,
      }),
      ...(newStatus === true && {
        new_video: true,
        new_article: true,
        new_audio: true,
        gurudev_quote: true,
        announcement: true,
      }),
    }));
  };



  const handleToggle = (key) => {
    setSettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };



  const handleSave = async () => {
    try {

      const {
        id,
        createdAt,
        updatedAt,
        deletedAt,
        user_id,
        ...payload
      } = settings;

      console.log(settings);


      const res = await dispatch(updateNotificationSetting(payload));
      console.log({ updateNotificationSetting: res });
      if (res?.meta?.requestStatus === "fulfilled") {
        setShowModal(true);
        setTimeout(() => {
          navigate("/settings/menu");
          setShowModal(false);
        }, 3000);
        await dispatch(getNotificationSetting());


      }

    } catch (err) {
      console.error("Update failed:", err);
    }
  };


  return (
    <section className="Notification_Settings Personalization">
      <div className="row justify-content-center">

        <div className="col-lg-12 col-md-10">
          <div className="top_small_banner">
            <img
              src="/assets/images/profile/settings/banners/notification_banner.png"
              className="banner_img"
              alt="banner"
            />
          </div>
        </div>

        <div className="col-lg-12 col-md-10">
          <div className="select_option_div">

            <p className="main_title_text">Notification Settings</p>

            {/* MASTER SWITCH */}
            <div className="noti_div">
              <p className="noti_text">Notifications</p>

              <div className="radio_holder">
                <Form.Check
                  type="switch"
                  checked={settings?.all_status || false}
                  onChange={handleMainToggle}
                />
              </div>
            </div>

            <p className="title_text">Notify Me About:</p>

            {/* OPTIONS */}
            <div className="option_holder">
              {options?.map((item) => (
                <div className="option_div" key={item.key}>
                  <p className="label_text">{item.label}</p>

                  <div className="radio_holder">
                    <Form.Check
                      type="checkbox"
                      checked={settings?.[item.key] || false}
                      disabled={!settings?.all_status} // ⭐ Smart UX
                      onChange={() => handleToggle(item.key)}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="btn_holder">
              <Pink_Btn btnText={"OK"} onClick={handleSave} />
            </div>

          </div>
        </div>

      </div>
      <Success_Modal
        successText="Notification Updated!"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Notification_Settings;
